import * as actionTypes from './actionTypes';
const redirectReducer = (state = { to: '', replace: false }, action) => {
    switch (action.type) {
        case actionTypes.REDIRECT:
            return { to: action.payload.path, replace: action.payload.replace };
        default:
            return state;
    }
};
export default redirectReducer;
//# sourceMappingURL=reducer.js.map